import { findMenuByLangKey } from '@/views/layout/menuRelocation'

export const ENERGY_ANALYSIS_PATH = '/pages/report/energyAnalysis'

/** 在数据中心「报表」组下注入前端维护的三级菜单 */
export function injectDataCenterReportExtras(menuTree, getLangValuesByKey, normalizeMenuName) {
  const reportGroup = findMenuByLangKey(
    menuTree,
    'menuGroupReport',
    getLangValuesByKey,
    normalizeMenuName
  )
  if (!reportGroup) {
    return menuTree
  }
  if (!reportGroup.childs) {
    reportGroup.childs = []
  }
  const labels = getLangValuesByKey('menuItemEnergyAnalysis').map(normalizeMenuName)
  const exists = reportGroup.childs.some(child => labels.includes(normalizeMenuName(child.name)))
  if (exists) {
    return menuTree
  }
  const displayName = getLangValuesByKey('menuItemEnergyAnalysis')[0] || '能耗分析'
  reportGroup.childs.push({
    id: 'virtual_energy_analysis',
    name: displayName,
    href: ENERGY_ANALYSIS_PATH,
    isShow: 'Y',
    seq: 999
  })
  reportGroup.childs.sort((a, b) => (a.seq || 0) - (b.seq || 0))
  return menuTree
}
